
import TickerHorizental from '~/components/Common/UI/TickerHorizental'

export default {
  name: 'NewsTicker',
  components: {
    TickerHorizental,
  },
  methods: {
    onUpdateNews(news) {
      // 부모(header/index.vue)로 전달
      this.$emit('update-news', news)
    },
  },
}
